module.exports = __webpack_public_path__ + "static/img/zlgj-company.c6883ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutus/zlgj-company.jpg
// module id = OnNj
// module chunks = 18